<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">{{ modalTitle }}</h5>
        <div class="component-body">
          <ul class="list-unstyled view-options">
            <li class="view-option" @click="handleClick('resetViewSettings')">
              Reset view to default
            </li>
            <li class="view-option" @click="handleClick('saveViewClicked')">
              Save view
            </li>
            <li class="view-option" @click="handleClick('loadViewClicked')">
              Load view
            </li>
          </ul>
        </div>
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "ChangeRegionModal",
  props: {
    modalTitle: String
  },
  data() {
    return {
      show: true
    };
  },
  methods: {
    handleClick(clickEvent) {
      this.show = false;
      this.$emit(clickEvent);
    },
    clickedCancel() {
      this.show = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-body {
    margin: 24px 0;

    .view-options {
      margin: 0;
      .view-option {
        cursor: pointer;
        margin-bottom: 2px;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
